import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';

import { adminIntegrationsRepository } from '@web/data/repositories';
import { PageSectionHead, SegmentedButton, useOrgContext } from '@web/ui/core';
import { t } from '@web/i18n';

import { CompaniesTab } from './companies_tab';
import { pendingKey } from './integrations_shared';
import { PendingTab } from './pending_tab';

type Tab = 'companies' | 'pending';

/**
 * Integrações (`kanban:integrations:*`): company first — pick a corporate group, see its chat
 * tools and send its IT the Teams connect link — plus the open links across
 * every company (Pendências).
 */
export function IntegrationsPage(): React.JSX.Element {
  const [tab, setTab] = useState<Tab>('companies');
  const [selected, setSelected] = useState<string | null>(null);
  const { orgId } = useOrgContext();
  const pending = useQuery({
    queryKey: pendingKey,
    queryFn: () => adminIntegrationsRepository.listPending(orgId),
  });

  return (
    <>
      <PageSectionHead title={t('integrations.page.title')} sub={t('integrations.page.sub')} />
      <div className="mb-4">
        <SegmentedButton ariaLabel={t('integrations.tabs.label')}>
          <SegmentedButton.Item
            label={t('integrations.tabs.companies')}
            isActive={tab === 'companies'}
            onClick={() => {
              setTab('companies');
            }}
          />
          <SegmentedButton.Item
            label={t('integrations.tabs.pending')}
            count={(pending.data?.links.length ?? 0) + (pending.data?.unlinked.length ?? 0)}
            isActive={tab === 'pending'}
            onClick={() => {
              setTab('pending');
            }}
          />
        </SegmentedButton>
      </div>
      {tab === 'companies' ? (
        <CompaniesTab selected={selected} onSelect={setSelected} />
      ) : (
        <PendingTab
          query={pending}
          onOpen={(groupId) => {
            setSelected(groupId);
            setTab('companies');
          }}
        />
      )}
    </>
  );
}
